import type { FC, PropsWithChildren } from 'react'
import React from 'react'

import { ErrorPage } from 'ErrorPage'
import { Route, IndexRoute } from 'react-router'
import type { Store } from 'redux'

import { InstrumentedErrorBoundary } from '@library/browser-errors'
import { BROWSER_ERROR_KEYS } from '@library/observability/browser'

import { client as clientRoutes } from 'config/routes'
import { MainLayout } from 'layouts/MainLayout'
import { MenuRouter } from 'routes/Menu/MenuRouter'
import { checkValidSession } from 'utils/routes'

import { MenuContainer } from './MenuContainer'
import { instrumentedOnEnter } from './utils/instrumentation'

const ErrorPageWrapper = () => (
  <MainLayout>
    <ErrorPage />
  </MainLayout>
)

const MenuPage: FC<PropsWithChildren<any>> = (props) => (
  <InstrumentedErrorBoundary
    errorKey={BROWSER_ERROR_KEYS.UNEXPECTED_MENU_PAGE_ERROR}
    fallback={ErrorPageWrapper}
  >
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <MenuContainer {...props} />
  </InstrumentedErrorBoundary>
)

const safeCheckValidSession = (store: Store<any, any>) =>
  instrumentedOnEnter(
    checkValidSession(store, clientRoutes.home, true),
    BROWSER_ERROR_KEYS.MENU_AUTHENTICATION_CHECK_ERROR,
    {},
  )

export const MenuRoute = (store: Store<any, any>) => (
  <Route path={clientRoutes.menu} component={MenuPage}>
    <IndexRoute component={MenuRouter} />
    <Route path=":orderId" component={MenuRouter} onEnter={safeCheckValidSession(store)} />
  </Route>
)
